import React from "react";
import Btn from "../components/Btn";

function Spotlight() {
  return (
    <div className="relative text-white flex w-full flex-col-reverse md:grid md:grid-cols-2 z-50 md:min-h-[60vh]">
      <div className="bg-[#5D567F] p-8 text-xl md:text-3xl text-center md:text-left flex flex-col gap-6 justify-center items-center uppercase">
        <div className="md:w-6/12 flex flex-col gap-3">
          <p className="font-bold">YOUR DAILY</p>
          <p className="p-d capitalize text-3xl md:text-5xl">Pore-bursting</p>
          <p className="font-bold">Regimen</p>
        </div>
        <div className="md:w-6/12 flex justify-start">
          <Btn text="shop now" />
        </div>
      </div>
      <div className="bg-spotlight bg-cover bg-center h-[40vh] md:h-full"></div>
    </div>
  );
}

export default Spotlight;
